/**
 * @description This file contains miscellaneous JavaScript functions and polyfills.
 */

import { arrayUnique } from "./helpers";

Array.prototype.unique = function (key) {
  return arrayUnique(this, key);
};

/**
 * Fire the fetch:request:success event when a fetch request is successful.
 */
(function() {
  var _fetch = window.fetch;

  window.fetch = function() {
    var args = arguments;

    return _fetch.apply(this, args).then(function(response) {
      var clonedResponse = response.clone();

      clonedResponse.text().then(function(text) {
        window.dispatchEvent(new CustomEvent('fetch:request:send', {
          detail: {
            url: response.url,
            response: text,
            method: args[0].method || 'GET',
            status: response.status,
          }
        }));
      });

      return response;
    });
  };
})();

/**
 * Fire the ajax:request:success event when an XMLHttpRequest is successful.
 */
(function() {
  var _open = XMLHttpRequest.prototype.open;
  var _send = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function(method, url) {
    this._requestMethod = method;
    this._requestUrl = url;
    return _open.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function(body) {
    var xhr = this;
    var originalOnReadyStateChange = xhr.onreadystatechange;

    xhr.onreadystatechange = function() {
      if (xhr.readyState === 4) {
        window.dispatchEvent(new CustomEvent('ajax:request:success', {
          detail: {
            url: new URL(xhr._requestUrl, window.location.origin).href,
            response: xhr.responseText,
            method: xhr._requestMethod,
            status: xhr.status,
          }
        }));
      }

      if (originalOnReadyStateChange) {
        originalOnReadyStateChange.apply(xhr, arguments);
      }
    };

    return _send.apply(this, arguments);
  };
})();